import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'

/**
 * Local vs R2: más completo en local, o remoto caído (404) con copia local.
 */
const StudySourceChoiceDlg = ({
  open,
  patientName,
  studyInstanceUID,
  localInstances,
  localBytes,
  remoteInstances,
  remoteSeries,
  remoteUnavailable,
  remoteError,
  onOpenLocal,
  onOpenRemote,
  onClose,
}) => {
  const localN = Number(localInstances) || 0
  const remoteN = Number(remoteInstances) || 0
  const seriesN = Number(remoteSeries) || 0
  const bytes = Number(localBytes) || 0
  const mb =
    bytes > 0 ? `${(bytes / (1024 * 1024)).toFixed(bytes >= 10 * 1024 * 1024 ? 0 : 1)} MB` : null
  const unavailable = !!remoteUnavailable

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      {...udvDialogProps}
    >
      <DialogTitle style={UDV_SURFACE.title}>
        {unavailable ? 'Manifest remoto no disponible' : '¿Qué copia abrir?'}
      </DialogTitle>
      <DialogContent style={UDV_SURFACE.content}>
        <Typography
          variant="body1"
          gutterBottom
          style={{ fontWeight: 600, color: '#f0f4f8' }}
        >
          {patientName || 'Estudio'}
        </Typography>
        {studyInstanceUID ? (
          <Typography
            variant="body2"
            style={{ wordBreak: 'break-all', ...UDV_SURFACE.muted }}
            gutterBottom
          >
            {studyInstanceUID}
          </Typography>
        ) : null}
        <Typography
          variant="body2"
          gutterBottom
          style={{ color: 'rgba(210, 220, 230, 0.92)' }}
        >
          Local: <strong>{localN}</strong> instancias
          {mb ? ` · ~${mb}` : ''}
        </Typography>
        <Typography
          variant="body2"
          gutterBottom
          style={{ color: 'rgba(210, 220, 230, 0.92)' }}
        >
          {unavailable ? (
            <>
              Remoto (ticket / R2): <strong>no disponible</strong>
              {remoteError ? ` (${remoteError})` : ''}
            </>
          ) : (
            <>
              Remoto (ticket / R2): <strong>{remoteN}</strong> instancias
              {seriesN > 0
                ? ` · ${seriesN} serie${seriesN === 1 ? '' : 's'}`
                : ''}
            </>
          )}
        </Typography>
        <Typography variant="body2" style={UDV_SURFACE.muted}>
          {unavailable
            ? 'El manifest en R2 falló, pero hay una copia en storage local. Podés abrirla sin borrar nada.'
            : 'Hay una copia local más completa que el manifest remoto. Elegí cuál abrir; el storage local no se borra al abrir el remoto.'}
        </Typography>
      </DialogContent>
      <DialogActions style={UDV_SURFACE.actions}>
        <Button onClick={onClose} style={UDV_SURFACE.btnGhost}>
          Cancelar
        </Button>
        {!unavailable ? (
          <Button onClick={onOpenRemote} style={UDV_SURFACE.btnGhost}>
            Abrir remoto
          </Button>
        ) : null}
        <Button
          onClick={onOpenLocal}
          style={UDV_SURFACE.btnPrimary}
          variant="contained"
          autoFocus
          disabled={localN <= 0}
        >
          Abrir local
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default StudySourceChoiceDlg
